<template>
  <div class="mt-4">
    <v-layout>
      <v-flex>
        <v-btn flat @click="handleGoBack">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
      <v-flex v-if="list && list.length > 0" class="text-xs-right">
        <v-btn color="primary" @click="showExportGroup = true">{{ $t('export') }}</v-btn>
      </v-flex>
    </v-layout>

    <v-container>
      <h3 class="headline">{{ $t('Broadcast Detail') }}</h3>
    </v-container>

    <v-container v-if="broadcast">
      <div>{{ $t('Broadcast Name') }}</div>
      <div class="primary--text">{{ broadcast.delivery_tag }}</div>
    </v-container>
    <v-divider></v-divider>

    <template v-if="broadcast && ['sent'].includes(broadcast.status)">
      <v-container>
        <v-data-table
          :headers="headers"
          :items="list"
          class="elevation-1"
          hide-actions
          style="width: 100%"
        >
          <template #items="props">
            <td>{{ props.item.phone_number }}</td>
            <td>{{ $t(`status_type.${props.item.status}`) }}</td>
          </template>
        </v-data-table>
        <div style="display: flex; justify-content: flex-end" class="mt-2">
          <v-pagination v-model="page" :length="pageLength" :total-visible="7" />
        </div>
      </v-container>
      <v-divider></v-divider>
    </template>

    <v-container>
      <div class="text-xs-center mt-2">
        <v-btn color="grey" outline @click="handleGoBack">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
      </div>
    </v-container>
    <ExportGroup
      v-model="showExportGroup"
      :total="total"
      :filename="`${broadcast.delivery_tag}-report`"
      :limit="1000"
      @onExport="onExportBroadcast"
    ></ExportGroup>
  </div>
</template>
<script>
import lineOfficialNotificationApi from '@/api/line-official-notification'
import { mapGetters } from 'vuex'
import ExportGroup from '@/components/elements/ExportGroup.vue'
export default {
  components: {
    ExportGroup
  },
  data() {
    return {
      broadcast: null,
      page: 1,
      limit: 10,
      list: [],
      total: 0,
      showExportGroup: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    headers() {
      return [
        { text: this.$t('mobile'), value: 'phone_number', sortable: false },
        { text: this.$t('Status'), value: 'status', sortable: false }
      ]
    },
    pageLength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    }
  },
  watch: {
    broadcast(val) {
      if (!val) return
      this.handleFetchDataLogStatus(val)
    },
    page(newVal, oldVal) {
      if (newVal != oldVal) {
        this.handleFetchDataLogStatus(this.broadcast)
      }
    }
  },
  methods: {
    handleGoBack() {
      this.$emit('go-back')
    },
    handleFillForm(broadcast) {
      this.broadcast = broadcast
    },
    async handleFetchDataLogStatus(broadcast) {
      try {
        if (!broadcast || !['sent'].includes(broadcast.status)) return
        const response = await lineOfficialNotificationApi.getLogLineOfficialNotificationBroadcast({
          params: {
            page_id: this.selectedBot.pageid,
            id: broadcast.id,
            limit: this.limit,
            offset: this.page * this.limit - this.limit
          }
        })
        const { status, data } = response
        if ([200].includes(status)) {
          this.list = []
          this.list = data.data || []
          this.total = data.total || 0
        }
      } catch (error) {
        console.error(error)
      }
    },
    async onExportBroadcast(callback) {
      if (callback) {
        let { limit, offset } = callback
        this.$store.dispatch('loading')
        const format_data = await this.getExportData(limit, offset, true)
        this.$store.dispatch('clear_loading')
        if (format_data) {
          callback.submitAoaData([
            [`Broadcast Name: ${this.broadcast.delivery_tag}`],
            [],
            ['Phone Number', 'Status'],
            ...format_data
          ])
        }
      }
    },
    async getExportData(limit, offset, isExport = false) {
      if (!this.broadcast.id) return
      const response = await lineOfficialNotificationApi.getLogLineOfficialNotificationBroadcast({
        params: {
          page_id: this.selectedBot.pageid,
          id: this.broadcast.id,
          limit: limit,
          offset: offset
        }
      })
      const { status, data } = response
      if ([200].includes(status) && isExport) {
        const dataExport = data.data || []
        return dataExport.map((item) => {
          const phoneNumber = item.phone_number ? item.phone_number : '-'
          const status = item.status ? item.status : '-'
          return [phoneNumber, status]
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcastView.vue